import React from 'react'
import { Helmet } from 'react-helmet'
import { DEFAULT_SEO } from '@pool/config/seo'

export const SeoTags = ({ title = DEFAULT_SEO.title, children }) => {
  // Note: Meta tags (title, description, og:*, twitter:*, canonical) and JSON-LD schemas
  // are in static HTML generated by generate-seo-pages.js - no need to duplicate here.
  // Helmet only handles: title updates for SPA navigation

  return (
    <Helmet>
      <title>{title}</title>
      {children}
    </Helmet>
  )
}
